module.exports = __webpack_public_path__ + "img/featureTreeGreen.88db3a0f.png";